import { useState } from "react";
import { Plus, Minus } from "lucide-react";
import { useI18n } from "@/lib/i18n";

const FAQ_KEYS = ["q1", "q2", "q3", "q4", "q5", "q6", "q7", "q8"];

export function Faq() {
  const { t } = useI18n();
  const [open, setOpen] = useState<number | null>(null);
  return (
    <section id="faq" className="py-24 px-6 scroll-mt-20">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-14">
          <h2 className="text-4xl md:text-5xl font-bold tracking-tight">
            {t("faq.title")} <span style={{ color: "#F97316" }}>{t("faq.titleHighlight")}</span>
          </h2>
        </div>
        <div className="space-y-4">
          {FAQ_KEYS.map((k, i) => {
            const isOpen = open === i;
            return (
              <div
                key={k}
                className="rounded-2xl transition-all"
                style={{
                  backgroundColor: "#0c1d50",
                  border: `1px solid ${isOpen ? "rgba(249,115,22,0.5)" : "rgba(255,255,255,0.08)"}`,
                  boxShadow: isOpen ? "0 0 30px rgba(249,115,22,0.08)" : "none",
                }}
              >
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? null : i)}
                  className="w-full flex items-center justify-between gap-4 text-left p-6"
                  aria-expanded={isOpen}
                >
                  <span className="text-white font-bold text-lg">{t(`faq.${k}`)}</span>
                  <span
                    className="shrink-0 w-8 h-8 rounded-full flex items-center justify-center"
                    style={{ backgroundColor: "rgba(249,115,22,0.12)", color: "#F97316" }}
                  >
                    {isOpen ? <Minus className="w-4 h-4" /> : <Plus className="w-4 h-4" />}
                  </span>
                </button>
                {isOpen && (
                  <div className="px-6 pb-6 -mt-2 leading-relaxed" style={{ color: "#A0A0A0" }}>
                    {t(`faq.a${i + 1}`)}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
